<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <notifications
        classes="app-notify"
        :duration="5000"
        :width="600"
        animation-name="v-fade-left"
        position="top right"
      >
      </notifications>
      <forgot-password-card header-color="green">
        <h4 slot="title" class="title">{{ $t("user.forgot_password") }}</h4>
        <p slot="action-title" class="action-title">
          {{ $t("user.email_forgot_password") }}
        </p>
        <p slot="description" class="description">
          {{ $t("user.enter_email_forgot_password") }}
        </p>
        <div slot="form-submit">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(submit)">
              <div class="md-layout" style="text-align: left">
                <!--  Email  -->
                <div class="md-layout-item md-size-100">
                  <label
                    class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label  required-field"
                    style="padding: 0"
                  >
                    {{ $t("user.your_email") }}
                  </label>
                  <ValidationProvider
                    vid="email"
                    :name="$t('user.your_email')"
                    rules="required|email"
                    v-slot="{ passed, failed, errors }"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <md-icon>mail</md-icon>
                      <md-input v-model="email"></md-input>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="failed">close</md-icon>
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon class="success" v-show="passed">done</md-icon>
                      </slide-y-down-transition>
                    </md-field>
                    <div class="validate-error">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
              <md-card-actions class="text-center">
                <md-button
                  type="submit"
                  class="md-success"
                  style="margin-right: 10px;"
                >
                  {{ $t("user.send_mail") }}
                </md-button>
              </md-card-actions>
            </form>
          </ValidationObserver>
        </div>
      </forgot-password-card>
    </div>
    <result-modal
      :modal-create="modalCreate"
      @closeModal="closeModal"
      :modal-data="modalData"
    >
    </result-modal>
  </div>
</template>

<script>
import { ForgotPasswordCard } from "@/components";
import { SlideYDownTransition } from "vue2-transitions";
import ResultModal from "../../../components/Modal/ResultModal";
import { AuthService } from "../../../services/auth.service";

export default {
  name: "EmailForgotPassword",
  components: {
    ResultModal,
    ForgotPasswordCard,
    SlideYDownTransition
  },
  data() {
    return {
      email: "",
      modalCreate: {
        show: false,
        action: "create"
      },
      modalData: {
        title: "",
        content: ""
      }
    };
  },
  methods: {
    submit() {
      this.sendEmailResetPass();
    },
    async sendEmailResetPass() {
      const response = await AuthService.sendEmailResetPass({
        email: this.email
      });
      if (!response) {
        this.modalCreate.show = true;
        this.modalData.title = this.$t("common.failure");
        this.modalData.success = false;
        return;
      }
      this.modalCreate.show = true;
      this.modalData.title = this.$t("common.success");
      this.modalData.content = response.original.message;
      this.modalData.success = true;
    },
    closeModal() {
      this.modalCreate.show = false;
      this.modalData.title = "";
      this.modalData.content = "";
      this.modalData.success = false;
      this.$store.commit("DESTROY_MODAL");
    }
  }
};
</script>

<style scoped></style>
